module.exports = __webpack_public_path__ + "static/media/AppStoreDownloadImage.01085a80.png";